import { faPause } from "@fortawesome/duotone-light-svg-icons"
import { faChevronRight } from "@fortawesome/pro-light-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Button, JoonColorExpanded, JoonUIColor } from "@joonapp/web-shared"
import { Typography } from "@joonapp/web-shared"
import dayjs from "dayjs"
import { useShallow } from "zustand/react/shallow"

import Overlay from "./Overlay"
import { useCoachOverlayStore } from "./useCoachOverlay"
import useUnpauseConfirmationModalStore from "./useUnpauseConfirmationModalStore"
import { useGetCoachSubscriptionQuery } from "../../../networking/coaching/queries"
import { CoachOverlayType } from "../../../types"

const PausedSubscriptionOverlay = () => {
  const { onOpen: onOpenUnpauseConfirmationModal } =
    useUnpauseConfirmationModalStore(
      useShallow((state) => ({ onOpen: state.onOpen }))
    )
  const { currentOverlay } = useCoachOverlayStore(
    useShallow((state) => ({ currentOverlay: state.currentOverlay }))
  )
  const { data: coachSubscriptionData, isLoading: isLoadingSubscription } =
    useGetCoachSubscriptionQuery()

  const unpauseDate = dayjs(
    coachSubscriptionData?.pause_collection_end_datetime
  ).format("MMM D")

  if (
    currentOverlay !== CoachOverlayType.PAUSED_SUBSCRIPTION ||
    isLoadingSubscription
  ) {
    return <></>
  }

  const handleUnpause = () => {
    onOpenUnpauseConfirmationModal()
  }

  return (
    <Overlay color={JoonColorExpanded.red100}>
      <div className="w-full flex flex-col gap-2 items-start">
        <div className="flex flex-row gap-1 bg-red-400 items-center px-2 py-1 rounded-md w-fit">
          <FontAwesomeIcon
            icon={faPause}
            color={JoonUIColor.icon.inverted}
            fontSize={12}
          />
          <Typography
            variant="bodySmall"
            textAlign="center"
            color={JoonUIColor.text.inverted}
            className="w-fit"
          >
            Paused until: {unpauseDate}
          </Typography>
        </div>
        <Typography variant="bodyBold">
          Your Coaching account is currently Paused!
        </Typography>
        <Typography variant="bodySmall">
          While paused, you won't be charged the monthly Coaching Subscription
          fee. Your account will automatically unpause on {unpauseDate}. Or you
          can always unpause sooner by tapping the button below.
        </Typography>

        <Button
          text="Unpause now"
          buttonType="primary"
          rightIcon={faChevronRight}
          onClick={handleUnpause}
          fullWidth
          className="mt-2"
        />
      </div>
    </Overlay>
  )
}

export default PausedSubscriptionOverlay
